<template>
  <div class="markdown-content" v-html="renderedContent"></div>
</template>

<script>
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export default {
  props: {
    content: String,
    highlightedSentences: Array,
    referenceNumber: String,
  },
  computed: {
    renderedContent() {
      if (!this.content) return '';
      let html = marked(this.content);
      
      if (this.highlightedSentences && this.highlightedSentences.length > 0) {
        this.highlightedSentences.forEach((sentence, index) => {
          const escapedSentence = sentence.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const regex = new RegExp(`(${escapedSentence})`, 'gi');
          html = html.replace(regex, `<span class="highlighted-quote" data-highlight-index="${index}">$1</span>`);
        });
      }

      return DOMPurify.sanitize(html);
    }
  },
  watch: {
    highlightedSentences: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.$emit('highlight-ready');
        });
      }
    }
  }
}
</script>

<style scoped>
.markdown-content {
  padding: 16px;
}
.highlighted-quote {
  background-color: yellow;
  font-weight: bold;
}
</style>